// Sheet size is priced as a fixed lb-equivalent surcharge on the base price,
// using the cake's own lbRate - same delta formula as the round-cake weight
// selector (see cakeCatalog.js SHEET CAKES comment). Shared between
// ProductDisplay.jsx (actual sheet surcharge) and Item.jsx ("From" price),
// since sheet-only products are always in sheet mode.
export const SHEET_EXTRA_LBS = { quarter: 3, half: 5 };
